/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateMutationResponse,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivatePathParams,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateQueryParams,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate400,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate401,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate500,
} from "../../types/individualPaymentEditorsController/PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate.ts";

function getPostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateUrl(
  financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivatePathParams["financialPersonId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/individualpayment/financial-people/${financialPersonId}/inactivate` as const,
  };
  return res;
}

/**
 * @description Cancela as parcelas abertas (aguardando integração/pendentes) e inativa o plano. Com 'reactivate=true' reabre como pendentes as parcelas renegociadas vinculadas. Migrado do legado IndividualPayment/Inactivate (InactivatePlan). **(Requer Authorization para autenticação)**
 * @summary Inativa o plano financeiro (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId/inactivate}
 */
export async function postApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate(
  financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivatePathParams["financialPersonId"],
  params?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate400
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate401
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivate500
    >,
    unknown
  >({
    method: "POST",
    url: getPostApiV1IndividualpaymentFinancialPeopleFinancialpersonidInactivateUrl(
      financialPersonId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
